module.exports = __webpack_public_path__ + "img/yi_weechat.41c038bd.jpg";